import React from 'react';
import { connect } from 'react-redux';
import DemoModeHeaderBody from '../../../features/demoMode/reading/DemoModeHeader/DemoModeHeaderBody/DemoModeHeaderBody';
import DemoControlsContainer from './DemoControlsContainer';
import DemoTourContainer from './DemoTourContainer';
import { selectors } from '../../../root/reading/root';
import { setHasDemoTypeTransitionEnded } from '../../../api/demoMode/reading/demoModeActions';

const mapStateToProps = state => {
    return {
        hasError: selectors.hasErrorExcludingUnauthorized(state),
        isGuidedTourOn: selectors.getIsGuidedTourOn(state),
        location: selectors.getLocation(state),
        hasTourStarted: selectors.getHasTourStarted(state),
    };
};
const mapDispatchToProps = dispatch => ({
    setHasDemoTypeTransitionEnded: isTransitionBool => {
        dispatch(setHasDemoTypeTransitionEnded(isTransitionBool));
    },
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        demoTourMap: <DemoTourContainer />,
        demoControls: <DemoControlsContainer />,
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(DemoModeHeaderBody);
